import styles from './HomeCategorySection.module.scss';
import { Box, Typography } from '@mui/material';
import Image from 'next/image';
import imgLoader from '../../../imgloader';
import { sections } from '../../../commons/Constants/CategorySection';
import CategoryProductCard from '../../../commons/components/ui/Cards/CategoryProductCard/CategoryProductCard';
import { getProducts } from '../../../commons/utils/productsHelper';
const HomeCategorySection = () => {
  const products = getProducts();
  const content = sections.map((section) => ({
    ...section,
    products: section.products.map((prod) => {
      const info = products[prod.productKey] || {};
      // Use recurringPrice if initialPrice is 0 or not present, else use initialPrice
      let value = 0;
      if (info.initialPrice && Number(info.initialPrice) !== 0) {
        value = info.initialPrice;
      } else if (info.recurringPrice) {
        value = info.recurringPrice;
      }
      return {
        ...prod,
        price: `Starting from $${Number(value).toFixed(2)}`,
      };
    }),
  }));

  return (
    <>
      {content.map((section) => (
        <Box
          key={section.title}
          className={`${styles.wrapper} ${styles[section.key]} ${section.title === 'Energy & Vitality' && styles.heroSection} ${section.title === 'Brain & Mental Performance' && styles.heroSectionImg}`}
        >
          <Box className={styles.inner}>
            {/* left image */}
            <Box className={styles.imageContainer}>
              <Image
                src={section.leftImage}
                alt={section.title}
                loader={imgLoader}
                layout="fill"
                placeholder="blur"
                blurDataURL={section.leftImage}
                className={styles.image}
              />
            </Box>

            {/* right content */}
            <Box className={styles.contentContainer}>
              <Box className={styles.headingContent}>
                <Typography variant="h2" className={styles.title}>
                  {section.title}
                </Typography>
                {/* Keeping below commented in future if we need to show description again */}
                {/* <Typography component="h4" className={styles.subtitle}>
                  {section.subtitle}
                </Typography> */}
              </Box>

              <Box className={styles.productsContainer}>
                {section.products.map((prod, i) => (
                  <Box key={i} className={styles.productWrapper}>
                    <CategoryProductCard {...prod} />
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      ))}
    </>
  );
};

export default HomeCategorySection;
